module.exports = __webpack_public_path__ + "img/unggah_dan_unduh_data.77ee2f23.svg";